import { useApiQuery } from '../useApiQuery';
import { operationsClient, apiGet } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { AvailabilityResponse } from '@/types/scheduler';

export function useBookingAlternatives(
  bookingId: string,
  enabled = true,
  durationMinutes?: number | null,
) {
  return useApiQuery<AvailabilityResponse>({
    queryKey: [...schedulerKeys.booking(bookingId), 'alternatives', durationMinutes ?? null],
    queryFn: () =>
      apiGet<AvailabilityResponse>(
        operationsClient,
        schedulerEndpoints.bookingAlternatives(bookingId),
        durationMinutes != null ? { params: { durationMinutes } } : undefined,
      ),
    enabled: enabled && Boolean(bookingId),
    showErrorToast: false,
  });
}
